import Login from "../Views/Authentication/LogIn.vue";
import Home from "../Views/Home/HomeView.vue";
// import { watch } from "vue";

import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/store/auth";

import { usePermissionStore } from "../store/helper/menuPaths";
import { useDRPermissionStore } from "../store/helper/DRmenuPaths";
import { hasDigiMenuPath, useDRMenuStore } from "../store/helper/DRMenuStore";

import { useContorlPermissionStore } from "@/store/helper/controlPanelMenuPath";
import { useControlPanelMenuStore } from "../store/helper/controlpanelMenuStore";

import { useOnboardingStepsStore } from "@/store/helper/Onboarding";
import { useDrOnboardingStepsStore } from "@/store/helper/DrOnboarding";

// const checkRegistration = (to, from, next) => {
//   const onboardingStore = useOnboardingStepsStore();
//   console.log("Onboarding", onboardingStore);
//   if (onboardingStore.register?.id) {
//     next();
//   } else {
//     next({ name: "register" });
//   }
// };

const routes = [
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
  { path: "/login", name: "login", component: Login },
  {
    path: "/logout",
    name: "logout",
    meta: {
      requiresAuth: true,
    },
    beforeEnter: async (to, from, next) => {
      const authStore = useAuthStore();

      await authStore.logOut();

      next({ name: "login" });
    },
  },
  {
    name: "forgotPassword",
    path: "/forgot-password",
    component: () => import("../Views/Authentication/ForgetPassword.vue"),
  },

  {
    path: "/reset-Password",
    component: () => import("../Views/Authentication/ResetPassword.vue"),
  },
  {
    name: "Reset Forgot Password",
    path: "/resetForgotPassword/:username/:transactionId",
    component: () => import("../Views/Authentication/ResetForgotPassword.vue"),
  },
  {
    path: "/403",
    component: () => import("@/Views/error/error-403.vue"),
  },
  {
    name: "/404",
    meta: { requiresAuth: false },
    path: "/404",
    component: () => import("@/Views/error/error-404.vue"),
  },
  {
    path: "/onboarding",
    name: "Onboarding",
    header: "Navigation",
    redirect: { path: "/onboarding/register" },

    component: () => import("@/Views/onboarding/MainView.vue"),
    children: [
      {
        path: "/onboarding/register",
        name: "register",
        component: () => import("@/Views/onboarding/RegisterView.vue"),
      },
      {
        path: "/onboarding/step1",
        name: "general",
        component: () => import("@/Views/onboarding/steps/Step1.vue"),
        beforeEnter: (to, from, next) => {
          const registerInfo1 = JSON.parse(
            sessionStorage.getItem("registerInfo1"),
          );

          if (registerInfo1) {
            next();
          } else {
            next({ name: "register" });
          }
        },
      },
      {
        path: "/onboarding/step2",
        name: "payment_and_receipt",
        component: () => import("@/Views/onboarding/steps/Step2.vue"),
        beforeEnter: (to, from, next) => {
          const onboardingStore = useOnboardingStepsStore();

          if (onboardingStore.step1.completed) {
            next();
          } else {
            next({ name: "register" });
          }
        },
      },
      {
        path: "/onboarding/step3",
        name: "delivery",
        component: () => import("@/Views/onboarding/steps/Step3.vue"),
        beforeEnter: (to, from, next) => {
          const onboardingStore = useOnboardingStepsStore();

          if (onboardingStore.step2.completed) {
            next();
          } else {
            next({ name: "register" });
          }
        },
      },
      {
        path: "/onboarding/step4",
        name: "category_and_products",
        component: () => import("@/Views/onboarding/steps/Step4.vue"),
        beforeEnter: (to, from, next) => {
          const onboardingStore = useOnboardingStepsStore();
          if (onboardingStore.step4.completed) {
            next();
          } else {
            // next();

            next({ name: "register" });
          }
        },
      },
      {
        path: "/onboarding/step5",
        name: "summary",
        component: () => import("@/Views/onboarding/steps/Step5.vue"),
        beforeEnter: (to, from, next) => {
          const onboardingStore = useOnboardingStepsStore();
          if (onboardingStore.step4.completed) {
            next();
          } else {
            next({ name: "register" });
          }
        },
      },
      {
        path: "/onboarding/success",
        name: "success",
        component: () => import("@/Views/onboarding/SuccessView.vue"),
        beforeEnter: (to, from, next) => {
          const onboardingStore = useOnboardingStepsStore();
          if (
            onboardingStore.step3.completed ||
            onboardingStore.step4.completed ||
            onboardingStore.step5.completed
          ) {
            next();
          } else {
            next({ name: "summary" });
          }
        },
      },
    ],
  },
  {
    path: "/drOnboarding",
    name: "DrOnboarding",
    header: "Navigation",
    redirect: { path: "/DrOnboarding/register" },
    component: () => import("@/Views/drOnboarding/mainView.vue"),
    children: [
      {
        path: "/drOnboarding/register",
        name: "DrRegister",
        component: () => import("@/Views/drOnboarding/registerView.vue"),
      },
      {
        path: "/drOnboarding/step1",
        name: "DRgeneral",
        component: () => import("@/Views/drOnboarding/steps/stepOne.vue"),
        beforeEnter: (to, from, next) => {
          const registerInfo1 = JSON.parse(
            sessionStorage.getItem("registerInfo1"),
          );
          const DrOnboardingStepsStore = useDrOnboardingStepsStore();

          if (registerInfo1) {
            next();
          } else {
            next({ name: "DrRegister" });
          }
        },
      },
      {
        path: "/drOnboarding/step2",
        name: "DRreceipt",
        component: () => import("@/Views/drOnboarding/steps/stepTwo.vue"),
        beforeEnter: (to, from, next) => {
          const DrOnboardingStepsStore = useDrOnboardingStepsStore();
          const registerInfo1 = JSON.parse(
            sessionStorage.getItem("registerInfo1"),
          );

          if (registerInfo1 || DrOnboardingStepsStore.step1.completed) {
            next();
          } else {
            next({ name: "DrRegister" });
          }
        },
      },
      {
        path: "/drOnboarding/step3",
        name: "DRsms",
        component: () => import("@/Views/drOnboarding/steps/stepThree.vue"),
        beforeEnter: (to, from, next) => {
          const DrOnboardingStepsStore = useDrOnboardingStepsStore();
          const registerInfo1 = JSON.parse(
            sessionStorage.getItem("registerInfo1"),
          );

          if (registerInfo1 || DrOnboardingStepsStore.step2.completed) {
            next();
          } else {
            next({ name: "DrRegister" });
          }
        },
      },
      {
        path: "/drOnboarding/step4",
        name: "DRsummary",
        component: () => import("@/Views/drOnboarding/steps/stepFour.vue"),
        beforeEnter: (to, from, next) => {
          const DrOnboardingStepsStore = useDrOnboardingStepsStore();
          const registerInfo1 = JSON.parse(
            sessionStorage.getItem("registerInfo1"),
          );

          if (registerInfo1 || DrOnboardingStepsStore.step2.completed) {
            next();
          } else {
            next({ name: "DrRegister" });
          }
        },
      },
      {
        path: "/drOnboarding/success",
        name: "DRsuccess",
        component: () => import("@/Views/drOnboarding/drSuccessView.vue"),
        beforeEnter: (to, from, next) => {
          const DrOnboardingStepsStore = useDrOnboardingStepsStore();
          if (
            DrOnboardingStepsStore.step2.completed ||
            DrOnboardingStepsStore.step3.completed
          ) {
            // Mark onboarding as completed when user reaches success screen
            DrOnboardingStepsStore.MARK_ONBOARDING_COMPLETED();
            next();
          } else {
            next({ name: "DrRegister" });
          }
        },
      },
    ],
  },

  {
    path: "/",
    name: "home",
    meta: { requiresAuth: true },
    redirect: { path: "/dashboard" },
    component: Home,
    children: [
      {
        path: "/MyProfile",
        component: () => import("../Views/rdep-view/UserProfile/MyProfile.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/tenant-Profile",
        component: () =>
          import(
            "../Views/rdep-view/UserProfile/TenantProfile/TenantProfile.vue"
          ),
      },
      {
        path: "/store-Profile",
        component: () =>
          import(
            "../Views/rdep-view/UserProfile/StoreProfile/StoreProfile.vue"
          ),
      },

      {
        path: "/dashboard",
        icon: "ri-dashboard-line  ri-lg",
        component: () => import("../Views/rdep-view/dashboard/IndexView.vue"),
        beforeEnter: (to, from, next) => {
          const authStore = useAuthStore();
          if (
            authStore.auth.landingPage === "rdep-receipt-v2" ||
            authStore.auth.privileges?.includes("CPRL_DASHBOARD_UI")
          ) {
            return next({ path: "/rdep-receipt/dashboardV2" });
          } else if (
            authStore.auth.landingPage === "rdep-receipt-v3" ||
            authStore.auth.privileges?.includes("PHILIPS_DASHBOARD_UI")
          ) {
            return next({ path: "/rdep-receipt/dashboardV3" });
          } else if (authStore.auth.landingPage === "/rdep-receipt") {
            return next({ path: "/rdep-receipt/dashboard" });
          } else if (
            authStore.auth.landingPage === "/control-panel" ||
            authStore.auth.landingPage === "control-panel"
          ) {
            return next({ path: "/control-panel/solutions" });
          } else {
            return next();
          }
        },
        meta: { isPosMenu: false },
      },

      {
        path: "carts/allCarts",
        component: () => import("../Views/rdep-view/carts/AllCarts.vue"),
        meta: { isPosMenu: true },
      },
      // {
      //   name: "Cart Details",
      //   path: "carts/allCarts/cartDetails/:cartId",
      //   component: () => import("../Views/rdep-view/carts/CartDetail.vue"),
      // },
      {
        path: "orders/Dashboard",
        meta: { requiresAuth: true, isPosMenu: true },

        component: () =>
          import("../Views/rdep-view/orderDashboard/OrderDashboard.vue"),
      },
      {
        name: "Sales Report",
        path: "orders/salesReport",
        meta: { isPosMenu: true },

        component: () =>
          import("../Views/rdep-view/salesReport/SalesReport.vue"),
      },
      // {
      //   name: "Order Details",

      //   path: "orders/salesReport/orderDetail/:orderId",
      //   component: () =>
      //     import("../Views/rdep-view/salesReport/OrderDetail.vue"),
      // },
      {
        path: "orders/articleReport",
        meta: { isPosMenu: true },

        component: () =>
          import("../Views/rdep-view/articleReport/ArticleReport.vue"),
      },
      {
        path: "orders/deliveryReport",
        meta: { isPosMenu: true },

        component: () =>
          import("../Views/rdep-view/deliveryReport/DeliveryReport.vue"),
      },
      {
        path: "orders/discountReport",
        meta: { isPosMenu: true },

        component: () =>
          import("../Views/rdep-view/discountReport/DiscountReport.vue"),
      },
      {
        path: "orders/mediaReport",
        meta: { isPosMenu: true },

        component: () =>
          import("../Views/rdep-view/mediaReport/MediaReport.vue"),
      },
      {
        path: "orders/paymentMediaReport",
        meta: { isPosMenu: true },

        component: () =>
          import(
            "../Views/rdep-view/paymentMediaReport/PaymentMediaReport.vue"
          ),
      },
      {
        path: "orders/productSummaryReport",
        meta: { isPosMenu: true },

        component: () =>
          import(
            "../Views/rdep-view/productSummaryReport/ProductSummaryReport.vue"
          ),
      },
      {
        path: "orders/voidTransactionReport",
        meta: { isPosMenu: true },

        component: () =>
          import(
            "../Views/rdep-view/voidTransactionReport/VoidTransactionReport.vue"
          ),
      },
      {
        path: "returns/returnsReport",
        meta: { isPosMenu: true },

        component: () =>
          import("../Views/rdep-view/retrunReport/ReturnReport.vue"),
      },
      // {
      //   name: "Returns Report Details",

      //   path: "returns/returnReport/returnDetail/:returnId",
      //   component: () =>
      //     import("../Views/rdep-view/retrunReport/ReturnDetail.vue"),
      // },
      {
        path: "returns/creditNotes",
        meta: { isPosMenu: true },

        component: () =>
          import("../Views/rdep-view/creditNote/CreditReport.vue"),
      },
      {
        path: "returns/returnArticleReport",
        meta: { isPosMenu: true },

        component: () =>
          import(
            "../Views/rdep-view/returnArticleReport/ReturnArticleReport.vue"
          ),
      },
      {
        name: "Products",
        path: "products/products",
        meta: { isPosMenu: true },

        component: () => import("../Views/rdep-view/product/ProductView.vue"),
      },
      {
        path: "products/productsList",
        meta: { isPosMenu: true },

        component: () =>
          import("../Views/rdep-view/ProductList/ProductList.vue"),
      },
      {
        name: "Product Details",
        path: "product/productDetail/:id",
        component: () =>
          import("../Views/rdep-view/product/ProductDetailModal.vue"),
      },

      {
        path: "/products/products/addSingleProduct",
        meta: { isPosMenu: true },
        component: () =>
          import("../Views/rdep-view/product/AddSingleProduct.vue"),
      },
      {
        path: "products/catalogs",
        meta: { isPosMenu: true },

        component: () => import("../Views/rdep-view/catalogs/CatalogsView.vue"),
      },
      {
        path: "products/categories",
        meta: { isPosMenu: true },

        component: () => import("../Views/rdep-view/catagory/CategoryView.vue"),
      },
      {
        path: "products/pricebook",
        meta: { isPosMenu: true },

        component: () =>
          import("../Views/rdep-view/pricebook/PricebookView.vue"),
      },
      {
        name: "Pricebook Entries",
        meta: { isPosMenu: true },

        path: "products/pricebookEntries",
        component: () =>
          import("../Views/rdep-view/priceBookEntries/PricebookEntries.vue"),
      },
      {
        path: "promotion/masterpromotions",
        meta: { isPosMenu: true },

        component: () =>
          import("../Views/rdep-view/masterPromotion/MasterPromotions.vue"),
      },
      {
        path: "promotion/masterpromotions/createPromotion",
        meta: { isPosMenu: true },

        component: () =>
          import("../Views/rdep-view/masterPromotion/CreatePromotion.vue"),
      },
      {
        path: "promotion/storePromotion",
        meta: { isPosMenu: true },

        component: () =>
          import("../Views/rdep-view/storePromotions/StorePromotions.vue"),
      },

      {
        path: "inventory/InventoryList",
        meta: { isPosMenu: true },

        component: () =>
          import("../Views/rdep-view/inventory/InventoryList.vue"),
      },
      {
        path: "inventory/stockrequest(inward)",
        meta: { isPosMenu: true },

        component: () =>
          import("../Views/rdep-view/stockRequest/StockRequest.vue"),
      },

      {
        name: "Edit Stock Request",

        path: "inventory/stockRequest/editStock/:id",
        component: () =>
          import("../Views/rdep-view/stockRequest/EditStock.vue"),
      },
      {
        name: "Create Stock Request(Inward)",

        path: "inventory/stockrequest(inward)/createStockRequest",
        meta: { isPosMenu: true },

        component: () =>
          import("../Views/rdep-view/stockRequest/EditStock.vue"),
      },

      {
        path: "inventory/stockRequest/uploadModal/:id",
        component: () =>
          import("../Views/rdep-view/stockRequest/UploadModal.vue"),
      },
      {
        name: "Stock Request Details",
        path: "inventory/stockRequest/stockRequestDetails/:id",
        component: () =>
          import("../Views/rdep-view/stockRequest/DetailModal.vue"),
      },
      {
        name: "Stock Request GRN",
        path: "inventory/stockRequest/stockRequestGRNDetail/:id",
        component: () =>
          import("../Views/rdep-view/stockRequest/StockRequestGRN.vue"),
      },
      {
        name: "Bulk Stock Request",
        path: "inventory/bulkStockRequest",
        component: () =>
          import("../Views/rdep-view/bulkStockRequest/BulkStockRequest.vue"),
      },

      {
        path: "inventory/stocktransfer(outward)",
        meta: { isPosMenu: true },
        component: () =>
          import(
            "../Views/rdep-view/stockTransferOutward/StockTransferOutward.vue"
          ),
      },
      {
        meta: { isPosMenu: true },
        name: "Create Stock Transfer(Outward)",

        path: "inventory/stocktransfer(outward)/createStockTransfer",

        component: () =>
          import(
            "../Views/rdep-view/stockTransferOutward/createStockTransfer.vue"
          ),
      },
      {
        name: "Edit Stock Transfer",
        path: "inventory/stockTransfer/editStock/:id",
        component: () =>
          import("../Views/rdep-view/stockTransferOutward/EditStock.vue"),
      },
      {
        name: "Stock Transfer Details",
        path: "inventory/stockRequest/stockTransferDetails/:id",
        component: () =>
          import("../Views/rdep-view/stockTransferOutward/DetailModal.vue"),
      },
      {
        name: "Stock Transfer GTN",
        path: "inventory/stockRequest/stockTransferGTNDetail/:id",
        component: () =>
          import(
            "../Views/rdep-view/stockTransferOutward/StockTransferGTN.vue"
          ),
      },
      {
        path: "inventory/inwardHistory",
        meta: { isPosMenu: true },
        component: () =>
          import("../Views/rdep-view/inwardHistory/InwardHistory.vue"),
      },
      {
        path: "inventory/inventoryHistory",
        meta: { isPosMenu: true },
        component: () =>
          import("../Views/rdep-view/inventoryHistory/InventoryHistory.vue"),
      },
      {
        label: "Customers",
        icon: "ri-user-6-line ri-lg",
        name: "All Customers List",
        meta: { isPosMenu: true },
        path: "customers/allCustomersList",
        component: () =>
          import("../Views/rdep-view/customers/AllCustormersList.vue"),
      },
      {
        name: "Customer Details",
        path: "customers/customerDetail/:customerId",
        component: () =>
          import("../Views/rdep-view/customers/CustomerDetailModal"),
      },
      {
        label: "Solid Waste Management",
        icon: "ri-user-6-line ri-lg",
        name: "Establishment",
        meta: { isPosMenu: true },
        path: "solidwastemanagement/establishment",
        component: () =>
          import("../Views/rdep-view/establishment/EstablishmentList.vue"),
      },
      {
        name: "Invoices",
        meta: { isPosMenu: true },
        path: "solidwastemanagement/invoices",
        component: () => import("../Views/rdep-view/invoices/InvoicesList.vue"),
      },
      {
        path: "solidwastemanagement/establishment/create-establishment",
        meta: { isPosMenu: true },
        component: () =>
          import("../Views/rdep-view/establishment/CreateEstablishment.vue"),
      },
      {
        path: "manage/store",
        meta: { isPosMenu: true },
        component: () => import("../Views/rdep-view/store/StoreView.vue"),
      },
      {
        path: "manage/store/create-store",
        meta: { isPosMenu: true },
        component: () => import("../Views/rdep-view/store/Create-Store.vue"),
      },
      {
        path: "manage/user",
        meta: { isPosMenu: true },
        component: () => import("../Views/rdep-view/user/UserView.vue"),
      },
      {
        path: "manage/user/create-User",
        meta: { isPosMenu: true },

        component: () => import("../Views/rdep-view/user/Create-User.vue"),
      },
      {
        name: "User Detail",
        path: "manage/user/userDetail/:id",
        component: () => import("../Views/rdep-view/user/UserDetail.vue"),
      },
      {
        path: "manage/privileges",
        meta: { isPosMenu: true },
        component: () =>
          import("../Views/rdep-view/Privileges/PrivilegesView.vue"),
      },
      {
        path: "manage/roles",
        meta: { isPosMenu: true },
        component: () => import("../Views/rdep-view/Roles/RolesView.vue"),
      },
      {
        path: "manage/roles/create-roles",
        meta: { isPosMenu: true },
        component: () => import("../Views/rdep-view/Roles/CreateRoles.vue"),
      },
      {
        name: "Manage Roles",
        path: "manage/roles/manageRoles/:roleId",
        component: () => import("../Views/rdep-view/Roles/ManageRoles.vue"),
      },
      {
        path: "manage/bankhandover",
        meta: { isPosMenu: true },
        component: () =>
          import("../Views/rdep-view/bankHandover/BankHandover.vue"),
      },
      {
        path: "manage/bankhandover/createBankHandoverDeclaration",
        meta: { isPosMenu: true },

        component: () =>
          import(
            "../Views/rdep-view/bankHandover/createBankHandoverDeclaration.vue"
          ),
      },
      {
        path: "manage/Device",
        meta: { isPosMenu: true },

        component: () => import("../Views/rdep-view/device/DeviceView.vue"),
      },
      {
        name: "Payment Device Detail",
        path: "manage/paymentDevice/paymentDeviceDetail/:id",
        component: () => import("../Views/rdep-view/device/DeviceDetail.vue"),
      },
      {
        path: "manage/multiCurrency",
        meta: { isPosMenu: true },

        component: () =>
          import("../Views/rdep-view/multiCurrency/Multi-Currency.vue"),
      },
      {
        path: "manage/dataJobs",
        meta: { isPosMenu: true },

        component: () => import("../Views/rdep-view/dataJobs/DataJobs.vue"),
      },
      {
        path: "content/campaignlist",
        meta: { isPosMenu: true },
        component: () =>
          import("../Views/rdep-view/campaignList/campaignList.vue"),
      },
      {
        name: "Campaign Details",
        path: "content/campaignlist/campaignDetail/:id",
        component: () =>
          import("../Views/rdep-view/campaignList/campaignDetail.vue"),
      },
      {
        name: "Create Campaign",

        path: "content/campaignList/createCampaign",
        meta: { isPosMenu: true },

        component: () =>
          import("../Views/rdep-view/campaignList/CreateCampaign.vue"),
      },

      {
        path: "content/contentManagement",
        meta: { isPosMenu: true },

        component: () =>
          import("../Views/rdep-view/contentManagement/ContentManagement.vue"),
      },
      {
        name: "Create Content Management",
        path: "content/contentManagement/createManagement",
        meta: { isPosMenu: true },

        component: () =>
          import(
            "../Views/rdep-view/contentManagement/CreatecontentManagement.vue"
          ),
      },
      {
        name: "Distributor",
        path: "customers/distributor",
        meta: { isPosMenu: true },
        component: () =>
          import("../Views/rdep-view/distributor/DistributorView.vue"),
      },
      // {
      //   name: "Edit Content",
      //   path: "content/contentManagement/EditcontentManagement/:id",
      //   component: () =>
      //     import(
      //       "../Views/Content/ContentManagement/EditcontentManagement.vue"
      //     ),
      // },

      /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      // Routes for Digital Receipt

      {
        path: "/rdep-receipt",
        redirect: "/rdep-receipt/dashboard",
      },
      {
        path: "/rdep-receipt/dashboard",
        meta: { isDRMenu: false },
        component: () =>
          import("../Views/rdep-receipt/Dashboard/receiptDashboard.vue"),
      },
      {
        path: "/rdep-receipt/dashboardV2",
        meta: { isDRMenu: false },
        component: () =>
          import("../Views/rdep-receipt/Dashboard/mcdDashboard.vue"),
      },
      {
        path: "/rdep-receipt/dashboardV3",
        meta: { isDRMenu: false },
        component: () =>
          import("../Views/rdep-receipt/Dashboard/PhilipsDashboard.vue"),
      },
      {
        path: "/rdep-receipt/dashboardV4",
        meta: { isDRMenu: false },
        component: () =>
          import("../Views/rdep-receipt/Dashboard/RKDashboard.vue"),
      },
      {
        path: "/rdep-receipt/reports/digitalreceiptreport",
        meta: { isDRMenu: true },
        component: () =>
          import("../Views/rdep-receipt/views/Report/DigitalReceiptReport.vue"),
      },
      {
        path: "/rdep-receipt/reports/digitalreceiptreportV2",
        meta: { isDRMenu: true },
        component: () =>
          import(
            "../Views/rdep-receipt/views/Report/DigitalReceiptReportV2.vue"
          ),
      },
      {
        path: "/rdep-receipt/reports/transactionSummaryReport",
        meta: { isDRMenu: true },
        component: () =>
          import(
            "../Views/rdep-receipt/views/Report/TransactionSummary/TransactionSummary.vue"
          ),
      },
      {
        path: "/rdep-receipt/reports/unprocessedrequestslogreport",
        meta: { isDRMenu: true },
        component: () =>
          import("../Views/rdep-receipt/views/Report/ReceiptLog.vue"),
      },
      {
        path: "/rdep-receipt/reports/productsWithoutHSNCodeReport",
        meta: { isDRMenu: true },
        component: () =>
          import(
            "../Views/rdep-receipt/views/Report/ProductsWithoutHSNCodeReport.vue"
          ),
      },
      {
        path: "/rdep-receipt/settings/invokeintegration",
        meta: { isDRMenu: true },

        component: () =>
          import("../Views/rdep-receipt/views/Settings/InvokeIntegration.vue"),
      },
      {
        path: "/rdep-receipt/settings/visualassets",
        meta: { isDRMenu: true },
        component: () =>
          import(
            "../Views/rdep-receipt/views/Settings/Visual_Assets/Visual_Assets.vue"
          ),
      },
      {
        path: "/rdep-receipt/settings/socialchannel",
        meta: { isDRMenu: true },

        component: () =>
          import(
            "../Views/rdep-receipt/views/Settings/SocialChannel/SocialChannel.vue"
          ),
      },
      {
        path: "/rdep-receipt/settings/termandpolicy",
        meta: { isDRMenu: true },

        component: () =>
          import(
            "../Views/rdep-receipt/views/Settings/TermAndPolicy/TermAndPolicy.vue"
          ),
      },
      {
        path: "/rdep-receipt/settings/storeprofile",
        meta: { isDRMenu: true },

        component: () =>
          import(
            "../Views/rdep-receipt/views/Settings/StoreProfile/StoreProfile.vue"
          ),
      },
      {
        path: "/rdep-receipt/settings/certificate",
        meta: { isDRMenu: true },

        component: () =>
          import(
            "../Views/rdep-receipt/views/Settings/Certificate/CertificateView.vue"
          ),
      },
      {
        path: "/rdep-receipt/settings/store",
        meta: { isDRMenu: true },

        component: () =>
          import("../Views/rdep-receipt/views/Settings/Store/ReceiptStore.vue"),
      },
      {
        path: "/rdep-receipt/settings/store/createstore",
        meta: { isDRMenu: true },

        component: () =>
          import("../Views/rdep-receipt/views/Settings/Store/CreateStore.vue"),
      },
      {
        path: "/rdep-receipt/settings/users",
        meta: { isDRMenu: true },

        component: () =>
          import("../Views/rdep-receipt/views/Settings/User/ReceiptUser.vue"),
      },
      {
        path: "/rdep-receipt/settings/users/createUser",
        meta: { isDRMenu: true },

        component: () =>
          import("../Views/rdep-receipt/views/Settings/User/CreateUser.vue"),
      },
      {
        path: "/rdep-receipt/settings/co2_report",
        meta: { isDRMenu: true },

        component: () =>
          import("../Views/rdep-receipt/views/Settings/Co2Emission.vue"),
      },
      {
        path: "/rdep-receipt/manage/dataJobs",
        meta: { isDRMenu: true },

        component: () => import("../Views/rdep-view/dataJobs/DataJobs.vue"),
      },
      {
        path: "/rdep-receipt/downloadreports/downloadreports",
        meta: { isDRMenu: true },
        component: () =>
          import(
            "../Views/rdep-receipt/views/DownloadReport/downloadReport.vue"
          ),
      },

      // router for control panel
      {
        path: "/control-panel/solutions",
        name: "solutionsManagement",
        meta: { isControlPanelMenu: true },
        component: () =>
          import("../Views/control-panel/solutions/solutions.vue"),
      },
      {
        path: "/control-panel/plans",
        name: "plans",
        meta: { isControlPanelMenu: true },
        component: () => import("../Views/control-panel/plans/plans.vue"),
      },
      {
        path: "/control-panel/subscriptions",
        name: "subscriptions",
        meta: { isControlPanelMenu: true },
        component: () =>
          import("../Views/control-panel/subscriptions/subscriptions.vue"),
      },
    ],
  },

  {
    path: "/crmservice",
    name: "crm",
    component: () => import("../Views/customer-service/mainView.vue"),
    redirect: { path: "/CICdashboard" },

    children: [
      {
        name: "cicDashboard",
        path: "/CICdashboard",
        component: () => import("../Views/customer-service/dashboardView.vue"),
        meta: { requiresAuth: true },
      },
      {
        name: "cicInteraction",
        path: "/interaction",
        component: () =>
          import("../Views/customer-service/interactionView.vue"),
        meta: { requiresAuth: true },
      },
      {
        name: "cicDetail",
        path: "/detail-view/:id",
        component: () => import("../Views/customer-service/DetailView.vue"),
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    name: "cicQrForm",
    path: "/qrform",
    component: () => import("../Views/customer-service/QrForm.vue"),
    meta: { requiresAuth: false },
  },
];

//This MenuItems is used to populate the main menu in navbar component
export const menuItems = [
  {
    path: "/dashboard",
    label: "Dashboard",
    icon: "ri-dashboard-line  ri-lg",
    // component: DashBoardVue,
    // component: () => {
    //   const user = useAuthStore.auth.currentUser;
    //   if (user.landingPage === "/" || user.landingPage === "") {
    //     console.log("dashboard");
    //     DashBoardVue;
    //   } else if (user.landingPage === "rdep-recepit") {
    //     ReceiptDasboard;
    //     console.log(" Receipt dashboard");
    //   }
    // },
  },
  {
    label: "Carts",
    icon: "ri-shopping-cart-line  ri-lg",

    children: [
      {
        label: "All Carts",
        path: "/carts/allCarts",
        // component: () => import("../components/Views/Cart/Cart.vue"),
      },
    ],
  },
  {
    name: "Orders",
    label: "Orders",
    icon: "ri-shopping-bag-line  ri-lg",

    children: [
      {
        label: "Dashboard",
        path: "/orders/orderDashboard",
      },
      {
        name: "Sales Report",
        label: "Sales Report",
        path: "/orders/salesReport",
      },
      {
        label: "Article Report",
        path: "/orders/articleReport",
      },
      {
        label: "Delivery Report",
        path: "/orders/deliveryReport",
      },
      {
        label: "Discount Report",
        path: "/orders/discountReport",
      },
      {
        label: "Media Report",
        path: "/orders/mediaReport",
      },
      {
        label: "Payment Media Report",
        path: "/orders/paymentMediaReport",
      },
      {
        label: "Product Summary Report",
        path: "/orders/productSummaryReport",
      },
      {
        label: "Void Transaction Report",
        path: "/orders/voidTransactionReport",
      },
    ],
  },
  {
    label: "Returns",
    icon: "ri-loop-left-line  ri-lg",
    children: [
      {
        label: "Returns Report",
        path: "/return/returnsReport",
      },
      {
        label: "Credit Notes",
        path: "/return/creditNote",
      },

      {
        label: "Return Article Report",
        path: "/return/returnArticleReport",
      },
    ],
  },
  {
    label: "Products",
    icon: "ri-briefcase-line  ri-lg",

    children: [
      {
        label: "Products",
        path: "/products/products",
      },
      {
        label: "Catalogs",
        path: "/products/catalogs",
      },
      {
        label: "Categories",
        path: "/products/categories",
      },
      {
        label: "Pricebook",
        path: "/products/pricebook",
      },
      {
        label: "Pricebook Entries",
        path: "/products/pricebookEntries",
      },
      {
        label: "Master Promotions",
        path: "/promotion/masterpromotions",
      },
    ],
  },
  {
    label: "Promotion",
    icon: "ri-discount-percent-line ri-lg",

    children: [
      {
        label: "Master Promotions",
        path: "/promotion/masterpromotions",
      },
      {
        label: "Store Promotions",
        path: "/promotion/storePromotion",
      },
    ],
  },
  {
    label: "Inventory",
    icon: "ri-building-3-line  ri-lg",

    children: [
      {
        label: "Inventory List",
        path: "/inventory/allInventoryList",
      },
      {
        label: "Stock Request(Inward) ",
        path: "/inventory/stockrequest(inward)",
      },
      {
        label: "Stock Transfer(Outward) ",
        path: "/inventory/stocktransfer(outward)",
      },
      {
        label: "Bulk Stock Request ",
        path: "/inventory/bulkStockRequest",
      },
      {
        label: "Inward History ",
        path: "/inventory/inwardHistory",
      },
      {
        label: "Inventory History ",
        path: "/inventory/inventoryHistory",
      },
    ],
  },
  {
    label: "Customers",
    icon: "ri-user-6-line ri-lg",
    children: [
      {
        name: "All Customers List",
        label: "All Customers List",
        path: "/customers/allCustomersList",
      },
      {
        label: "Distributor",
        label: "Distributor",

        path: "/customers/distributor",
      },
    ],
  },
  {
    label: "Solid Waste Management",
    icon: "ri-user-6-line ri-lg",
    children: [
      {
        name: "Establishment",
        label: "Establishment",
        path: "solidwastemanagement/establishment",
      },
      {
        name: "Invoices",
        label: "Invoices",
        path: "solidwastemanagement/invoices",
      },
    ],
  },
  {
    label: "Manage",
    icon: "ri-user-settings-line ri-lg ",

    children: [
      {
        label: "Store",
        path: "/manage/store",
      },
      {
        label: "User",
        path: "/manage/user",
      },
      {
        label: "Bank Handover",
        path: "/manage/bankhandoverDeclaration",
      },
      {
        label: "Device",
        path: "/manage/paymentDevice",
      },
      {
        label: "Multi-Currency",
        path: "/manage/multiCurrency",
      },
      {
        label: "Data Jobs",
        path: "/manage/dataJobs",
      },
    ],
  },
  {
    label: "Content",
    icon: "ri-file-settings-line ri-lg",

    children: [
      {
        name: "Campaign List",
        label: "Campaign List",
        path: "/content/campaignlist",
      },
      {
        name: "Content Management",
        label: "Campaign List",
        path: "/content/contentmanagement",
      },
    ],
  },

  // {
  //   label: "Report",
  //   icon: "ri-file-list-3-line ri-lg ",

  //   children: [],
  // },
  // {
  //   label: "Setting",
  //   icon: "ri-settings-2-line ri-lg ",

  //   children: [],
  // },
  // {
  //   label: "Manage",
  //   icon: "ri-tools-line ri-lg ",

  //   children: [],
  // },
];

export const readReceiptRoutes = [
  {
    label: "Dashboard",
    icon: "ri-home-4-line ri-lg ",
    path: "/rdep-receipt/dashboard",
  },
  {
    label: "Dashboard",
    icon: "ri-home-4-line ri-lg ",
    path: "/rdep-receipt/dashboardV2",
  },
  {
    label: "Dashboard",
    icon: "ri-home-4-line ri-lg ",
    path: "/rdep-receipt/dashboardV3",
  },
  {
    label: "Reports",
    icon: "ri-article-line ri-lg",
    children: [
      {
        label: "Digital Receipt Report",
        path: "/rdep-receipt/reports/digitalreceiptreport",
      },
      {
        label: "Digital Receipt Report V2",
        path: "/rdep-receipt/reports/digitalreceiptreportV2",
      },
      {
        label: "Transaction Summary Report",
        path: "/rdep-receipt/reports/transactionSummaryReport",
      },
      {
        label: "Receipt Log",
        path: "/rdep-receipt/reports/unprocessedrequestslogreport",
      },
      {
        label: "Products Without HSN Code Report",
        path: "/rdep-receipt/report/productsWithoutHSNCodeReport",
      },
    ],
  },
  {
    label: "Settings",
    icon: "ri-settings-2-line ri-lg ",

    children: [
      {
        label: "Invoke Integration",
        path: "/rdep-receipt/settings/invokeintegration",
      },
      {
        label: "Visual Assets",
        path: "/rdep-receipt/settings/visualassets",
      },
      {
        label: "Social channel",
        path: "/rdep-receipt/settings/socialchannel",
      },
      {
        label: "Term and policy",
        path: "/rdep-receipt/settings/termandpolicy",
      },
      {
        label: "Store profile",
        path: "/rdep-receipt/settings/storeprofile",
      },
      {
        label: "Certificate",
        path: "/rdep-receipt/settings/certificate",
      },
      {
        label: "Store",
        path: "/rdep-receipt/settings/store",
      },
      {
        label: "Users",
        path: "/rdep-receipt/settings/users",
      },
      {
        label: " CO₂  Emission Report",
        path: "/rdep-receipt/settings/co2_report",
      },
    ],
  },
  {
    label: "Manage",
    icon: "ri-user-settings-line  ri-lg",

    children: [
      {
        label: "Data Jobs",
        path: "/rdep-receipt/manage/dataJobs",
        // component: () => import("../components/Views/Cart/Cart.vue"),
      },
    ],
  },
  {
    label: "Download Report",
    icon: "ri-file-chart-2-line ri-lg",

    children: [
      {
        label: "Download Report",
        path: "/rdep-receipt/downloadreports/downloadreports",
        // component: () => import("../components/Views/Cart/Cart.vue"),
      },
    ],
  },
];

export const controlPanelRoutes = [
  {
    label: "Subscriptions",
    icon: "ri-settings-2-line ri-lg",
    path: "/control-panel/subscriptions",
  },
  {
    label: "Plans",
    icon: "ri-user-settings-line  ri-lg",
    path: "/control-panel/plans",
  },
  {
    label: "Solutions",
    icon: "ri-file-chart-2-line ri-lg",
    path: "/control-panel/solutions",
  },
];

// Create router
const router = createRouter({
  history: createWebHistory(),
  routes: routes,
});

const publicPages = [
  "login",
  "forgotPassword",
  "Reset Forgot Password",
  "Onboarding",
  "register",
  "general",
  "payment_and_receipt",
  "delivery",
  "category_and_products",
  "summary",
  "success",
  "DrRegister",
  "DRgeneral",
  "DRreceipt",
  "DRsms",
  "DRsummary",
  "DRsuccess",
  "cicQrForm",
  "/404",
];

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();
  const permissionStore = usePermissionStore();
  const DRpermissionStore = useDRPermissionStore();
  const controlPanelStore = useContorlPermissionStore();

  // Check if the user is authenticated
  const isAuthenticated = authStore.isAuthenticated;

  // Define public pages that don't require authentication
  const isPublicPage = publicPages.includes(to.name);

  // Redirect unauthenticated users trying to access non-public pages to login
  if (!isAuthenticated && !isPublicPage) {
    return next({ name: "login" });
  }

  // Log out authenticated users trying to access the login page
  if (isAuthenticated && to.name === "login") {
    return next({ name: "home" });
  }

  if (isAuthenticated) {
    const landingPage = authStore.auth.landingPage;

    if (to.name === "home" || to.path === "/dashboard") {
      try {
        const DRmenuStore = useDRMenuStore();
        const menuItems = await DRmenuStore.fetchDigiMenuData();
        if (
          hasDigiMenuPath(menuItems, "/rdep-receipt/dashboardV4") &&
          authStore.auth.privileges?.includes("RK_DASHBOARD_UI")
        ) {
          return next({ path: "/rdep-receipt/dashboardV4" });
        }
      } catch (error) {
        console.error("Failed to resolve dashboard from menu data:", error);
      }
    }

    if (to.name === "home") {
      if (landingPage === "rdep-receipt" || landingPage === "/rdep-receipt") {
        return next({ path: "/rdep-receipt/dashboard" });
      } else if (landingPage === "rdep-receipt-v2") {
        return next({ path: "/rdep-receipt/dashboardV2" });
      } else if (
        landingPage === "/control-panel" ||
        landingPage === "control-panel"
      ) {
        return next({ path: "/control-panel/solutions" });
      } else if (landingPage === "/") {
        return next({ path: "/dashboard" });
      }
    }

    if (
      (landingPage === "rdep-receipt" || landingPage === "/rdep-receipt") &&
      to.path === "/dashboard"
    ) {
      return next({ path: "/rdep-receipt/dashboard" });
    }

    if (authStore.auth.privileges?.includes("PHILIPS_DASHBOARD_UI")) {
      if (to.path === "/rdep-receipt/dashboard") {
        return next({ path: "/rdep-receipt/dashboardV3" });
      }
    } else {
      if (to.path === "/rdep-receipt/dashboardV3") {
        return next({ path: "/rdep-receipt/dashboard" });
      }
    }

    if (authStore.auth.privileges?.includes("CPRL_DASHBOARD_UI")) {
      if (to.path === "/rdep-receipt/dashboard") {
        return next({ path: "/rdep-receipt/dashboardV2" });
      }
    } else {
      if (to.path === "/rdep-receipt/dashboardV2") {
        return next({ path: "/rdep-receipt/dashboard" });
      }
    }
  }

  // POS Menu permission check
  if (to.matched.some((record) => record.meta.isPosMenu)) {
    try {
      if (!permissionStore.isInitialized) {
        await permissionStore.initialize();
      }
      if (!permissionStore.isPathAllowed(to.path)) {
        console.warn(
          `Access restricted: ${to.path} is not in the allowed POS menu items`,
        );
        return next("/404");
      }
    } catch (error) {
      console.error("Error initializing POS permission store:", error);
      return next("/login");
    }
  }

  // DR Menu permission check
  if (to.matched.some((record) => record.meta.isDRMenu)) {
    try {
      if (!DRpermissionStore.isInitialized) {
        await DRpermissionStore.initialize();
      }
      if (!DRpermissionStore.isDRPathAllowed(to.path)) {
        console.warn(
          `Access restricted: ${to.path} is not in the allowed DR menu items`,
        );
        return next("/404");
      }
    } catch (error) {
      console.error("Error initializing DR permission store:", error);
      return next("/login");
    }
  }
  // Control Panel permission check
  // ✅ Control Panel permission check — only runs for /control-panel/* routes
  if (to.path.startsWith("/control-panel")) {
    try {
      if (!controlPanelStore.isInitialized) {
        await controlPanelStore.initialize();
      }
      if (!controlPanelStore.isControlPanelPathAllowed(to.path)) {
        console.warn(
          `Access restricted: ${to.path} is not in the allowed Control Panel menu items`,
        );
        return next("/404");
      }
    } catch (error) {
      console.error(
        "Error initializing Control Panel permission store:",
        error,
      );
      return next("/login");
    }
  }

  // If all checks pass, allow navigation to proceed
  next();
});

// Catch ChunkLoadError and reload
router.onError((error) => {
  const pattern = /Loading CSS chunk|Loading chunk \d+ failed/;
  if (pattern.test(error.message)) {
    console.warn("[ChunkLoadError] Detected. Reloading the app...");
    window.location.reload();
  }
});
export default router;
